<div class="icons-container">
  <div class="icons">
    @for (icon of icons; track $index) {
      <mat-icon
        svgIcon="{{ icon }}"
        (click)="selectIcon(icon)"
        [class.selected]="(data.icon$ | async) === icon"
      ></mat-icon>
    }
  </div>
</div>
